import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SearchIconLoader from './SearchIconLoader';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  suggestedFilterToken: {
    marginLeft: theme.spacing(0.5),
  },
});

const StartAdornment = ({
  className,
  classes,
  test,
  isSearching,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
      test={test}
    >
      <SearchIconLoader
        isSearching={isSearching}
      />
    </Box>
  );
};

StartAdornment.defaultProps = {
  className: '',
  test: null,
};

StartAdornment.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  test: PropTypes.string,
  isSearching: PropTypes.bool.isRequired,
};

export default withStyles(styles)(StartAdornment);
